import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";
import { Compare } from "../common/slider";
import { useState } from "react";

function Offer3TrawaRolka() {
  const [activeTransform, setActiveTransform] = useState(1);

  const handleChooseTransform = (index: number) => {
    setActiveTransform(index);
  };
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/trawa-z-rolki-Large.jpeg"
          alt="Trawnik z rolki - zakładanie trawy z rolki - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Zakładanie trawnika z rolki z siatką na krety Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Błyskawiczny efekt zielonego dywanu w Twoim ogrodzie na Kaszubach
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Marzysz o gęstym, soczyście zielonym trawniku wokół domu w Gdańsku, Gdyni, Kartuzach lub Wejherowie bez czekania na wzrost nasion? Oferujemy kompleksowe zakładanie trawników z rolki wraz z montażem siatki przeciw kretom i profesjonalnym przygotowaniem gleby przy użyciu <a href="/zakladanie-ogrodu/usluga-glebogryzarki" className="underline hover:opacity-80">glebogryzarki separacyjnej</a>. Ciesz się idealnym trawnikiem już w jeden dzień!
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Zakładanie trawnika z rolki
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              W ramach usługi zakładania trawnika
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Dlaczego warto powierzyć nam zakładanie trawnika?
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <p>
            Chcesz, aby trawnik wokół Twojego domu pięknie się prezentował?
            Zadzwoń do nas. Wykonywanie trawnika jest jedną z usług
            realizowanych przez naszą firmę ogrodniczą. Wieloletnie
            doświadczenie, pasja oraz wiedza gwarantują wysoką jakość wykonanych
            prac.
          </p>
          <h2 id="1">Zakładanie trawnika z rolki</h2>
          <p>
            Głównym zadaniem trawników jest ozdobienie przestrzeni otaczającej
            budynek. Idealnie przycięta, zielona trawa sprawia, że przestrzeń
            prezentuje się bardzo elegancko. Niestety stworzenie perfekcyjnego
            trawnika nie jest prostym zadaniem. Wymaga właściwego przygotowania
            gleby, dobrania odpowiedniego gatunku traw i właściwego położenia
            trawy z rolki. Dlatego zakładanie trawników warto zlecić naszej
            firmie. Dzięki temu nie musisz się o nic martwić, a Twój trawnik
            będzie się perfekcyjnie prezentował i wzbudzał podziw wśród innych
            osób.
          </p>

          <h3 id="2">W ramach usługi zakładania trawnika:</h3>
          <ul>
            <li>
              zaprojektujemy trawnik, tak aby długo prezentował się idealnie;
            </li>
            <li>
              przygotowujemy podłoże pod trawę:
              <ul>
                <li>
                  wykonujemy prace porządkowe - oczyszczamy teren z kamieni,
                  śmieci, gruzu, liści oraz chwastów;
                </li>
                <li>
                  na życzenie klienta układamy instalację nawadniającą przed
                  wykonaniem trawnika;
                </li>
                <li>
                  przy pomocy glebogryzarki napowietrzamy i spulchniamy glebę,
                  co sprzyja wzrostowi świeżej trawy;
                </li>
                <li>
                  ulepszamy jakość gleby - sprawdzamy jej pH i w zależności od
                  potrzeb zakwaszamy lub odkwaszamy glebę;
                </li>
                <li>
                  niwelujemy (wyrównujemy powierzchnię gleby) za pomocą ciągnika
                  John Deere;
                </li>
                <li>
                  na glebie układamy specjalną siatkę, aby zapobiec występowaniu
                  nieestetycznych kretowisk;
                </li>
                <li>
                  wykańczamy brzegi trawnika zgodnie z preferencjami klienta,
                  np. palisadami, ekobordem lub kostką granitową, co ułatwia
                  późniejszą pielęgnację.
                </li>
              </ul>
            </li>
            <li>
              doradzamy, jak samodzielnie nawozić glebę - dobieramy odpowiedni
              nawóz do pH gleby;
            </li>
            <li>dobieramy trawę z rolki do indywidualnych potrzeb klienta;</li>
            <li>
              układamy trawę z rolki, dzięki czemu można od razu cieszyć się
              pięknym i zadbanym trawnikiem;
            </li>
            <li>
              po zakończeniu pracy doradzamy, jak pielęgnować trawnik, aby jak
              najdłużej cieszyć się jego pięknem.
            </li>
          </ul>

          <h3 id="3">Dlaczego warto powierzyć nam zakładanie trawnika?</h3>
          <p>
            Nasza firma powstała z pasji do ogrodów. Dzięki kompleksowo
            wykonywanym usługom możemy pochwalić się wieloma zrealizowanymi
            projektami. W naszej pracy stawiamy na wieloletnie doświadczenie,
            miłość do natury oraz nieustanne poszerzanie naszej wiedzy. Dlatego
            łączymy tradycyjne rozwiązania z nowoczesnymi technologiami,
            używając m.in. maszyn John Deere i Bobcat. Cały czas poszerzamy
            naszą wiedzę o nowinki ogrodnicze.
          </p>

          <p>
            Kiedy powierzysz nam zakładanie swojego trawnika, możesz być pewien,
            że:
          </p>
          <ul>
            <li>
              efekt naszej pracy jest widoczny od razu i utrzymuje się na długo;
            </li>
            <li>
              otrzymujesz kompleksową usługę - od projektu aż po wysoką jakość
              realizacji, a na życzenie klienta także instalację nawadniającą;
            </li>
            <li>otrzymasz korzystniejszą cenę za kompleksową usługę.</li>
          </ul>

          <p>
            Nie czekaj. Zamów już dziś usługę zakładania trawnika z rolki, abyś
            mógł cieszyć się pięknym trawnikiem bez żadnego wysiłku. Dzięki nam
            Twój ogród stanie się idealnym miejscem do spędzania czasu z rodziną
            i przyjaciółmi!
          </p>
        </div>
      </section>
      <section className="px-6 pb-6 lg:px-24 lg:pb-12 flex flex-col gap-6">
        <div className="w-full bg-gray-100 rounded-xl p-6 flex flex-col gap-6">
          <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between">
            <div className="flex flex-col items-start justify-start gap-2">
              <h2 className="uppercase color-yellow text-xl">Transformacje</h2>
              <h3 className="text-3xl lg:text-5xl color-green">
                Zobacz jak odmieniamy{" "}
                <span className="color-yellow">ogrody</span>
              </h3>
            </div>
            <a href="/kontakt">
              <button className="button-green">Bezpłatna wycena</button>
            </a>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            <div
              id="chooseTransform1"
              onClick={() => handleChooseTransform(1)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-1-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 1 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform2"
              onClick={() => handleChooseTransform(2)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-2-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 2 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform3"
              onClick={() => handleChooseTransform(3)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-3-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 3 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform4"
              onClick={() => handleChooseTransform(4)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-4-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 4 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform5"
              onClick={() => handleChooseTransform(5)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-5-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 5 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform6"
              onClick={() => handleChooseTransform(5)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-6-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 6 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform7"
              onClick={() => handleChooseTransform(7)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-7-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 7 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform8"
              onClick={() => handleChooseTransform(8)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-8-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 8 - efekt końcowy"
              />
            </div>
            <div
              id="chooseTransform9"
              onClick={() => handleChooseTransform(9)}
              className="group overflow-hidden flex flex-col items-center justify-center cursor-pointer rounded-xl relative h-[200px]"
            >
              <img
                className="group-hover:scale-110 transition duration-300 ease-linear w-full h-full object-cover"
                src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-9-koniec.jpeg"
                alt="Trawnik z rolki realizacja nr 9 - efekt końcowy"
              />
            </div>
          </div>
          <div className="">
            <div
              className={`w-full ${activeTransform === 1 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-1-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-1-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 2 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-2-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-2-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 3 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-3-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-3-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 4 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-4-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-4-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 5 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-5-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-5-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 6 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-6-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-6-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 7 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-7-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-7-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
            <div
              className={`w-full ${activeTransform === 8 ? "block" : "hidden"}`}
              id="transform1"
            >
              <Compare
                firstImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-8-start.jpeg"
                secondImage="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/trawnikzrolki-8-koniec.jpeg"
                firstImageClassName="object-cover scale-110"
                secondImageClassname="object-cover scale-110"
                className="h-[650px] rounded-xl overflow-hidden"
                slideMode="hover"
              />
            </div>
          </div>
        </div>
      </section>
            {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-rolki-1-Large.jpeg"
              alt="Trawnik z rolki - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-rolki-2-Large.jpeg"
              alt="Trawnik z rolki - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-rolki-3-Large.jpeg"
              alt="Trawnik z rolki - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px]">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/trawa-z-rolki-4-Large.jpeg"
              alt="Trawnik z rolki - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer3TrawaRolka;
